import SendTestEmailModal from './SendTestEmailModal';

export default SendTestEmailModal;
